import { alpha } from "@mui/material";
import { buttonHeight } from "../../va-package/ui/button/interface";

export default function Button(theme: any) {
  return {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }: any) => ({
          borderRadius: 50,
          boxShadow: "unset",
          "&:hover": {
            boxShadow: "unset",
          },
          height: buttonHeight,
          fontWeight: 400,
        }),
      },
      variants: [
        {
          props: { variant: "text" },
          style: {
            color: theme.palette.text.primary,
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.2),
              color: theme.palette.primary.dark,
            },
          },
        },
      ],
    },
  };
}
